import {sendVerificationEmail} from './sendVerificationEmail';
import {checkVerificationEmailCode} from './checkVerificationEmailCode';

export const emailVerificationService = {
  sendVerificationEmail,
  checkVerificationEmailCode,
};


